export default __webpack_public_path__ + "static/sfff-f9c56d32be9f0acb6fdc522e25f2ca12.png";